import { persistentAtom } from "@nanostores/persistent";

import { GraphSummary } from "../../api";

export const MAX_RECENT_GRAPHS = 4;

export const $recentlyOpenedGraphs = persistentAtom<GraphSummary[]>(
  "recentlyOpenedGraphs",
  [],
  {
    decode: JSON.parse,
    encode: JSON.stringify,
  },
);
